import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import EditOwners from "features/People/Groups/EditGroup/EditOwners/EditOwners";
import { bindAction } from "interfaces";
import { connect, type ConnectedProps } from "react-redux";
import { getFilterOptions as getUsersFilterOptions } from "../../../Users/UsersOverview/state/filterActionCreators";
import { fetchTemplateOwners } from "../../state/thunks/TemplateOwnersThunk";

export type Props = PropsFromRedux & {
  templateId: number;
};

export const TemplateOwnersContainer = (props: Props) => {
  const { templateId, owners, fetchTemplateOwners, fetchFilterOptions, usersFilterOptions } = props;
  return (
    <EditOwners
      groupId={templateId}
      ownersOptions={owners}
      inherited={false}
      loadOwners={fetchTemplateOwners}
      getFilterOptions={fetchFilterOptions}
      filterOptions={usersFilterOptions}
      disableSelect={() => true}
    />
  );
};

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  return {
    owners: state.people.groupTemplate.owners,
    usersFilterOptions: state.people.usersOverview.filterOptions,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    fetchTemplateOwners: bindAction(fetchTemplateOwners, dispatch),
    fetchFilterOptions: bindAction(getUsersFilterOptions, dispatch),
  };
};

/* istanbul ignore next */
const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(TemplateOwnersContainer);
export default ConnectedComponent;
